import React from "react";
import * as Setting from "../Setting";
import { OssUrl } from "../Setting";


export default (props) => {
  const language = Setting.getLanguage();
  const spanStyle = {
    cursor: "pointer",
    fontWeight: 400,
    fontSize: "14px",
    lineHeight: "22px",
    marginLeft: "36px",
  };

  const toHome = () => {
    const protocol = window.location.protocol;
    const host = window.location.host.includes("zetyun.cn") ? window.location.host.split(".").toSpliced(0, 1, "catalog").join(".") : window.location.host.split(".").toSpliced(0, 1, "www").join(".");
    window.location.href = protocol + "//" + host;
  };

  // const toDocument = () => {
  //   const protocol = window.location.protocol;
  //   const host = window.location.host.split(".").toSpliced(0, 1, "community").join(".");
  //   window.open(protocol + "//" + host + "/community/developers/documentation");
  // };

  // const toProducts = () => {
  //   const protocol = window.location.protocol;
  //   const host = window.location.host.split(".").toSpliced(0, 1, "community").join(".");
  //   window.open(protocol + "//" + host + "/community/solutions");
  // };

  const changeLanguage = () => {
    const newLanguage = language === "zh" ? "en" : "zh";
    // Setting.setLanguage 内部已调用 i18next.changeLanguage，重复调用会让 languageChanged 事件触发两次
    Setting.setLanguage(newLanguage);
  };

  return (
    <div className="login-custom-header">
      <div
        style={{
          display: "flex",
          alignItems: "center",
          cursor: "pointer",
        }}
        onClick={toHome}>
        <img src={`${OssUrl}/logo_268e3cc7.svg`} alt="" style={{
          width: "136px",
          height: "48px",
          marginRight: "4px",
        }} />
        {/* <span style={{
          fontWeight: "bold",
          fontSize: "14px",
          color: "rgba(255,255,255,0.9)",
          lineHeight: "16px",
          maxWidth: "80px",
        }}>{i18next.t("header:Alaya New")}</span> */}
      </div>
      <div style={{
        display: "flex",
        alignItems: "center",
      }}>
        {/* <span style={{...spanStyle}} onClick={toHome}>{i18next.t("header:Home")}</span> */}
        {/* <span style={{...spanStyle}} onClick={toDocument}>{i18next.t("header:Document")}</span> */}
        {/* <span style={{...spanStyle}} onClick={toProducts}>{i18next.t("header:Products & Solutions")}</span> */}
        <span style={{...spanStyle}} onClick={changeLanguage}>{language === "zh" ? "EN" : "ZH"}</span>
      </div>
    </div>
  );
};
